import React, {useEffect} from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useSelector, shallowEqual } from "react-redux";

export const PublicRouteWrapper = (props) => {
  const {
    Component
  } = props;

  const history = useHistory();
  const location = useLocation();

  const {
    isAuthorized,
  } = useSelector(
    ({ auth }) => ({
      isAuthorized: auth.user != null && auth.user.sub != null,
    }),
    shallowEqual
  );

  useEffect(() => {
    if (isAuthorized) {
      // Check if there's a redirect parameter before redirecting to default
      const urlParams = new URLSearchParams(location.search);
      const redirectPath = urlParams.get('redirect');
      if (redirectPath) {
        history.push(redirectPath);
      } else {
        history.push('/keyword-spy');
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthorized]);

  return <Component />;

}